<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]"/>

        <!-------------外销标准订单支持自产与OEM混着下单------------------>
               <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece ddform_disable_cls">
            <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine" >
                        <el-form :model="order" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目合同编号" class="h-elformWrap-2">
                                <el-input v-model="order.orderSubContract" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="报价单" class="h-elformWrap-2">
                                <brupload
                                        :refid=order.orderProjectCode
                                        reftype = "外销项目-PI"
                                        :limit="1"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item label="PO凭证" class="h-elformWrap-2">
                                <brupload
                                        :refid=order.orderProjectCode
                                        reftype="外销项目-PO"
                                        :limit="1"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>
                        </el-form>
                    </div>

                </div>
            </div>
            <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form0" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="订单编码" v-if="this.order.sapCode" class="h-elformWrap-2">
                                <el-input v-model="this.order.sapCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" v-if="!showIsFree" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分销渠道" v-if="!showIsFree" class="h-elformWrap-2">
                                <el-input v-model="fxqdStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" v-if="showIsFree" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" placeholder="根据产品产地带出" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分销渠道" v-if="showIsFree" class="h-elformWrap-2">
                                <el-input v-model="fxqdStr" placeholder="根据产品产地带出" readonly></el-input>
                            </el-form-item>
							<el-form-item label="成本中心" prop="costCenter" class="h-elformWrap-2" v-if="showIsFree"
							:rules="[
							  { required: true, message: '请选择成本中心', trigger: 'change'},
							]">
							    <el-select v-model="order.costCenter" clearable filterable placeholder="选择产品后再选择" style="width: 100%;">
									<el-option v-for="item in costList" :key="item.index"
									:label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="订购原因" prop="businessReason" class="h-elformWrap-2" v-if="showIsFree"
							:rules="[
							  { required: true, message: '请选择订购原因', trigger: 'change'},
							]">
							    <brselect clearable category="business_reason" :v="order.businessReason"
							              v-model="order.businessReason"></brselect>
							</el-form-item>
							<!--
                            <el-form-item prop="note" label="备注" :rules="[
								  {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
								]"    class="h-elformWrap-2">
                                <el-input v-model="order.note" placeholder="请输入"></el-input>
                            </el-form-item>
                            -->
                            <el-form-item label="报价单" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传报价单', trigger: 'change'},
							]">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-PI"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item label="PO凭证" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传PO凭证', trigger: 'change'},
							]">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-PO"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>


                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称"
                                          :rules="[
								  { required: true, message: '请输入售达方名称', trigger: 'input'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                                    <i
                                            v-if="selectDailishang"
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="openShoudf">
                                    </i>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item prop="shipToAreaCode" label="送达方区域"   :rules="[
								  { required: true, message: '送达方区域不能为空', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <el-select v-model="order.shipToAreaCode" :v="order.shipToAreaCode" filterable placeholder="请选择" style="width:100%" @change="getAreaList">
                                    <el-option v-for="(item,index) in QYcountryList"
                                    :key="index" :label="`[${item.areacode}]${item.areaname}`" :value="item.areacode"></el-option>
                                </el-select>
                            </el-form-item>
                            <!--<el-form-item prop="shipToAreaCode" label="区域" v-if="disabled"  class="h-elformWrap-2">-->
                                <!--<el-select v-model="order.businessArea" :v="order.businessArea" filterable placeholder="请选择" style="width:100%" @change="getAreaUserList">-->
                                    <!--<el-option v-for="(item,index) in areaList"-->
                                               <!--:key="index" :label="`[${item.qycode}]${item.qyname}`" :value="item.qycode"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <el-form-item prop="shipToAreaCode" label="业务主人" v-if="disabled"  :rules="[
								  { required: true, message: '业务主人不能为空', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <el-select v-model="order.businessUser" :v="order.businessUser" filterable placeholder="请选择" style="width:100%">
                                    <el-option v-for="(item,index) in areaUserList"
                                               :key="index" :label="`[${item.ywcode}]${item.ywname}`" :value="item.ywcode"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="toCompanyname" label="港口" :rules="[
								  { required: true, message: '港口不能为空', trigger: 'input'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="gjmytk" label="国际贸易条款" :rules="[
								  { required: true, message: '请输入国际贸易条款', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="YlCommercialTerms" :v="order.gjmytk" :showcode="true"
                                          @change="ruleC" v-model="order.gjmytk"></brselect>
                            </el-form-item>

                            <el-form-item prop="fktj" label="付款条件" :rules="[
								  { required: true, message: '请输入付款条件', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="DD_FKTJ" :v="order.fktj" :showcode="true" @change="changeFktj"
                                          v-model="order.fktj"></brselect>
                            </el-form-item>

                            <el-form-item prop="fktj" label="上传信用证" v-if="shifouxinyzh" class="h-elformWrap-2">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-信用证"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <mdmselect clearable category="YLCurrency"
                                           :showcode="true"
                                           disabled
                                           :v="order.currencyCode" @change="changeCurrencyCode"
                                           v-model="order.currencyCode"></mdmselect>
                            </el-form-item>

<!--                            <el-form-item prop="kucun" label="库位" :rules="[
								  { required: true, message: '请选择库位', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="order_wx_kuwei"
                                           :v="order.kucun"
                                           v-model="order.kucun"></brselect>
                            </el-form-item>-->

                            <el-form-item prop="boxing" label="装箱方式" :rules="[
								  { required: true, message: '请选择装箱方式', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="zhuangxiang"
                                          :v="order.boxing"
                                          v-model="order.boxing"></brselect>
                            </el-form-item>

                            <!--
                            <el-form-item prop="boxNum" label="箱数(个)" :rules="[
								  { required: true, message: '请填写箱数', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <el-input v-model="order.boxNum" placeholder="箱数" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                            </el-form-item>
                            -->

                            <el-form-item prop="attachment" label="是否有备件" :rules="[
								  { required: true, message: '请选择是否有备件', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="shifou_keyong"
                                          :v="order.attachment"
                                          v-model="order.attachment"></brselect>
                            </el-form-item>
                            <el-form-item label="船期日期" class="h-elformWrap-2" :rules="[
								  { required: true, message: '船期日期不能为空', trigger: 'change'},
								]">
                                <el-date-picker v-model="order.shipDate" type="date"
                                    class="h-tableInput" :clearable="false"
                                    :picker-options="pickerOptions"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                          <el-form-item v-if="isAddress" prop="toAddress" label="收货地址" :rules="[
								  { required: true, message: '请输入收货地址', trigger: 'change'},
								]"  class="h-elformWrap-2">
                            <el-input v-model="order.toAddress" placeholder="请输入"></el-input>
                          </el-form-item>
                            <el-form-item v-if="isAddress" prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'change'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item v-if="isAddress" prop="firsttelephone" label="联系方式" :rules="[
								  { required: true, message: '请输入联系方式', trigger: 'change'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.firsttelephone" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item v-if="isAddress" prop="toCompany" label="收货单位" :rules="[
								  { required: true, message: '请输入收货单位', trigger: 'change'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.toCompany" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="overseaShname" label="境外收货人" :rules="[
								  { required: true, message: '境外收货人不能为空', trigger: 'input'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.overseaShname" placeholder="请输入"></el-input>
                            </el-form-item>
<!--                          <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" required>-->
<!--                            <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>-->
<!--                          </el-form-item>-->
                        </el-form>
                    </div>
                </div>
            </div>
        <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30 ljjtablepaddings3" style="margin: 20px 20px 0 20px;">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">产品信息</h1>
                    <el-button size="small" type="primary"
                               icon="el-icon-circle-plus"
                               style="margin-left: 50px;"
                               @click="showProcuct1" v-if="showaddProductRow">选择产品
                    </el-button>
                <span style="color: red;font-size: 12px;display: inline-block;padding-left: 20px;">计算逻辑已经修改，请直接填写成交价</span>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="productlist1"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        fixed
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类"
                        :show-overflow-tooltip="true"
                        fixed
                        min-width="90">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
						:show-overflow-tooltip="true"
                        fixed
                        min-width="110">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        min-width="200"
						:show-overflow-tooltip="true"
                        fixed
                        label="产品名称">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.materialName}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="oemDesc"
                        min-width="160"
                        :show-overflow-tooltip="true"
                        label="规格型号">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.oemDesc}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="factory"
                        label="产地"
                        min-width="100">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.factory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        min-width="100">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.proBenchmarkPrice}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        min-width="90">
                </el-table-column>
                <el-table-column
                        prop="expoPrice"
                        label="销售单价"
                        min-width="120" >
                    <!--<template slot-scope="scope">-->
                        <!--<el-input v-model="scope.row.expoPrice"-->
                                  <!--placeholder="请输入"-->
                                  <!--@keyup.native='keyupEvent($event,input)'-->
                                  <!--:readonly="scope.row.expoPriceReadonly"-->
                                  <!--class="DshuR h-tableInput" auto-complete="off"></el-input>-->
                    <!--</template>-->
                    <template slot-scope="scope">
                        <div v-if="showIsFree" style="text-align: right;">
                            {{ scope.row.expoPrice = new big(scope.row.finalPrice||0).minus(scope.row.feeyongj||0 ).minus( scope.row.feebaof||0 ).minus( scope.row.feeyunf||0).toFixed(2) }}
                        </div>
                        <div v-else style="text-align: right;">
                            {{ scope.row.expoPrice = new big(scope.row.finalPrice||0).minus(scope.row.feeyongj||0).minus(scope.row.feebaof||0).minus(scope.row.feeyunf||0).toFixed(2) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="feeyongj"
                        label="佣金/单台"
                        min-width="110">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.feeyongj"
                                  placeholder="请输入"
                                  @keyup.native='keyupEvent($event,input)'
                                  :readonly="scope.row.expoPriceReadonly"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="showFee"
                        prop="feebaof"
                        label="保费/单台"
                        min-width="110">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.feebaof"
                                  placeholder="请输入"
                                  @keyup.native='keyupEvent($event,input)'
                                  :readonly="scope.row.expoPriceReadonly"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="showFee"
                        prop="feeyunf"
                        label="运费/单台"
                        min-width="110">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.feeyunf"
                                  placeholder="请输入"
                                  @keyup.native='keyupEvent($event,input)'
                                  :readonly="scope.row.expoPriceReadonly"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="tejieshowflag"
                        prop="specialPrice"
                        label="特价"
                        min-width="220"
                    >
                    <template slot-scope="scope">
                        <el-select class="h-tableInput" v-model="scope.row.specialOfferCode"
                                   @change="changeTejia(scope.row)"
                                   placeholder="请选择" clearable  >
                            <el-option v-for="item in scope.row.tjlist"
                                       :key="item.tjdtid"
                                       :label="`[${item.tejia}] ${item.tjdes}`"
                                       :value="item.tjdtid">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column
                        v-if="tejieshowflag"
                        prop="specialPriceNum"
                        label="特价余量"
                        min-width="110">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.specialPriceNum}}
								</div>
							</template>
                </el-table-column>

<!--                <el-table-column-->
<!--                        v-if="dingzhishowflag"-->
<!--                        :show-overflow-tooltip="true"-->
<!--                        prop="extraDes"-->
<!--                        label="定制需求描述"-->
<!--                        width="150">-->
<!--                </el-table-column>-->

                <el-table-column
                        v-if="dingzhishowflag"
                        prop="extraDes"
                        label="改制大类"
                        :show-overflow-tooltip="true"
                        min-width="150">
                </el-table-column>
                <el-table-column
                        v-if="dingzhishowflag"
                        prop="specificReform"
                        label="改制要求"
                        :show-overflow-tooltip="true"
                        min-width="160">
                </el-table-column>

                <el-table-column
                        v-if="dingzhishowflag"
                        prop="extraPrice"
                        label="改制加价"
                        min-width="100" >
                    <template slot-scope="scope" v-if="scope.row.isCustommed == '1'">
                        <el-input v-model.number="scope.row.extraPrice" @change="calFinalPrice(scope.row)"
                                  placeholder="请输入"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="数量"
                        min-width="100">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.proNumber"
                                  oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
                                  placeholder="请输入"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="availableNum"
                        min-width="120"
                        :show-overflow-tooltip="true"
                        label="剩余预测数量">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        min-width="110"
                >

                    <template slot-scope="scope">
                        <el-input v-model="scope.row.finalPrice"
                                  placeholder="请输入"
                                  @keyup.native='keyupEvent($event,input)'
                                  :readonly="scope.row.expoPriceReadonly"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="totalprice"
                        label= "总价"
                        min-width="120"
                >
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber || 0).times(scope.row.finalPrice||0).toFixed(2) }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="hjmaozh"
                        :label="`毛重/${dwzhiliang}`"
                        min-width="90"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{   scope.row.hjmaozh = new big(scope.row.proNumber || 0).times(scope.row.wlmaozh||0)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="hjjinzh"
                        :label="`净重/${dwzhiliang}`"
                        min-width="90"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{  scope.row.hjjinzh = new big(scope.row.proNumber || 0).times(scope.row.wljinzh||0) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="hjtiji"
                        :label="`体积/${dwtiji}`"
                        min-width="90"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{  scope.row.hjtiji = new big(scope.row.proNumber || 0).times(scope.row.wltiji) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="measure"
                        label="尺寸(长宽高)"
                        :show-overflow-tooltip="true"
                        min-width="100">
                </el-table-column>

                <el-table-column
                    min-width="110"
                    prop="kucun"
                    :show-overflow-tooltip="true"
                    label="库位">
                    <template slot-scope="scope">
                        <brselect clearable category="order_wx_kuwei"
                                  :v="scope.row.kucun"
                                  v-model="scope.row.kucun"></brselect>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="factory"
                        min-width="90"
                        label="产地">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.factory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                         prop="zhifakufa"
                         label="直发/库发"
                         width="90"
                         :formatter='formatterZhifakufa'
                         :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                    prop="proType"
                    label="自产/OEM"
                    width="90"
                    :show-overflow-tooltip="true">
                </el-table-column>

                <el-table-column
                        prop="customsName"
                        label="报关名称"
                        :show-overflow-tooltip="true"
                        min-width="110">
                </el-table-column>
                <el-table-column
                        prop="note1"
                        label="备注"
                        min-width="160"
                >
                    <template slot-scope="scope">
                        <el-input class="h-tableInput" v-model="scope.row.note1"
                                  placeholder=""
                                   auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <!--产品列表 展示预测人，预测单号 ，改制内容 hyl-->
                <el-table-column
                        prop="ycrname"
                        label="预测人"
                        :show-overflow-tooltip="true"
                        min-width="90">
                </el-table-column>
                <el-table-column
                        prop="ycid"
                        label="预测单号"
                        :show-overflow-tooltip="true"
                        min-width="160">
                </el-table-column>

                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="deleteThis(scope.row)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="background-color: rgb(94, 182, 233);" v-if="showaddProductRow" @click="showProcuct1">
                <img src="../../assets/images/pimg/jiahao.png" alt="">
            </div>
            <div class="jieguo" v-if="!showIsFree">
                <span class="jieguo_label">{{order.currencyCode || ''}}总价</span>
                <span class="jieguo_value">
                    {{ order.orderPrice }}
                </span>

                <span class="jieguo_label" style="width: 2rem;">RMB总价</span>
                <span class="jieguo_value">{{ order.orderPriceRbm }}</span>

                <span class="jieguo_label" v-show="needxinjin">现金余额</span>
                <span class="jieguo_value" v-show="needxinjin">{{ this.cashBalance }}</span>

                <span class="jieguo_label" v-show="needxinjin">现金占用</span>
<!--                <span class="jieguo_value">{{ order.orderPriceXj = (this.cashBalance-order.orderPriceRbm<=0?this.cashBalance:order.orderPriceRbm)}}</span>-->
                <span class="jieguo_value" v-show="needxinjin">{{ order.orderPriceXj = this.needxinjin?(order.orderPrice||0):0}}</span>

                <span class="jieguo_label" v-show="needxindai">信贷选择</span>
                <span class="jieguo_value" v-show="needxindai">
                    <el-select class="ljjsales" v-model="order.creditid" clearable
                               placeholder="请选择" @change="creditChange">
                        <el-option v-for="item in creditData"
                                   :key="item.id"
                                   :label="item.cid!=null ? `信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`:'请选择'"
                                   :value="item.id">
                            <div style="color: #8492a6; font-size: 12px"  v-if="item.cid!=null">
                                <i style="float: left">{{ item.creCategory==1?'中信保':item.creCategory==0?'内部专属信贷':item.creCategory==2?'内部通用信贷':'' }} {{item.cid==null ? '':'('+item.cid+')'}}&nbsp;</i>&nbsp;
                                <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                <i style="float: right; ">信贷账期：{{ item.paymentdate }}天</i>
                            </div>
                        </el-option>
                    </el-select>
                </span>
                <span class="jieguo_label" v-show="needxindai">信贷占用</span>
                <span class="jieguo_value" v-show="needxindai">{{ order.orderPriceXd }}</span>

                <span class="jieguo_label">净价值</span>
                <span class="jieguo_value">{{(order.orderNetWorth = order.orderPrice )}}</span>

            </div>
            <div class="jieguo" v-if="!showIsFree">
                <span class="jieguo_label" style="width: 2rem;">总件数</span>
                <span class="jieguo_value">{{ order.allNum }}</span>
                <span class="jieguo_label">毛重汇总/{{this.dwzhiliang}}</span>
                <span class="jieguo_value">{{ order.allhjmaozh }}</span>
                <span class="jieguo_label">净重汇总/{{this.dwzhiliang}}</span>
                <span class="jieguo_value">{{(order.allhjjinzh )}}</span>
                <span class="jieguo_label">体积汇总/{{this.dwtiji}}</span>
                <span class="jieguo_value">{{order.allhjtiji }}</span>
				<span class="jieguo_label" style="background: transparent;"></span>
				<span class="jieguo_value"></span>
            </div>
            <div class="jieguo">
              <span class="jieguo_label">总佣金合计</span>
              <span class="jieguo_value">{{ order.allfeeyongj }}</span>
              <span class="jieguo_label" v-if="showFee">总保费合计</span>
              <span class="jieguo_value" v-if="showFee">{{(order.allfeebaof )}}</span>
              <span class="jieguo_label" v-if="showFee">总运费合计</span>
              <span class="jieguo_value" v-if="showFee">{{order.allfeeyunf }}</span>
              <span class="jieguo_label" style="background: transparent;" v-if="!showFee"></span>
              <span class="jieguo_value" v-if="!showFee"></span>
              <span class="jieguo_label" style="background: transparent;" v-if="!showFee"></span>
              <span class="jieguo_value" v-if="!showFee"></span>

              <span class="jieguo_label" style="background: transparent;"></span>
              <span class="jieguo_value"></span>
              <span class="jieguo_label" style="background: transparent;"></span>
              <span class="jieguo_value"></span>
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


        <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
        <!--物料-->
        <waixiaowxwl :visible.sync="showwuliaodialog1"
                     v-if="showwuliaodialog1"
                     @choseObj="choseWuliao1"
                     :ddlx="ddlx"
                     :xmcode="xmcode"
                     :usercode="order.soldToCode"
                     :currencyCode="order.currencyCode"
                     :country="order.shipToAreaCode"
              title="选择预测单"/>
        <!--售达方-->
        <shoudf :visible.sync="showshdfdialog"
                v-if="showshdfdialog"
                @choseObj="choseshoudf"
                oneflag
                :usercode="currentUser"
                :ddlx="ddlx"
                :xszz="order.saleGroupCode"
                title="选择售达方"/>
        <!--地址信息-->
        <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
	<div v-if="taskstatus=='0'">
	    <div class="anniu" v-if="!resubmit">
			<el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
			<el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
			<el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
	    </div>
	    <div class="anniu" v-else>
			<el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
			<el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
			<el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
	    </div>
	</div>
	<div class="anniu" v-if="taskstatus == '1'">
		<el-button class="h-btn h-bBtn h-bgblueQ2"  @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
	</div>
</div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'
    import waixiaowxwl from '../../components/dialog/wxwl-waixiao'
    import shoudf from '../../components/dialog/selectshdf'
    import _ from "loadsh";

    export default {
        components: {
            waixiaowxwl, shoudf
        },
        data() {
            return {
                errorMsg:'',
                submitChongfuFlag:true,
                //有国家大区的国家
                QYcountryList:[],
                areaList:[],
                areaUserList:[],
                costList:[],

                showIsFree:false,
                isYX:false, //是否元析
                resubmit:false,
                instid:null,
                taskstatus:0,

                showhistory:false,

                isAddress:false,
                selectDailishang:true,


                showwuliaodialog1:false,
                showwuliaodialog2:false,
                showshdfdialog:false,
                showdizhiflag:false,
                currentUser:null,
                showaddProductRow:true,
                showFee:true,

                //showdelProductRow: true,

                //是否需要信贷
                needxindai:true,
                needxinjin:true,
                //付款方式，不需要信贷
                fjksnotjy:['HT02','LC50'],
                //上传信用证
                shifouxinyzh:false,
                //特价
                tejieshowflag:false,
                //定制展示
                dingzhishowflag:false,

                //单位
                dwzhiliang:null,
                dwtiji:null,
                //现金余额
                cashBalance:0,
                //项目编码
                xmcode:null,
                ddlx:null,
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                order:{
                    shipDate:null,
                    businessUser:null,
                    businessArea:null,
                    kucun:null,//库存地点
                    sapcode:null,//订单编码
                    id:null, // 主键
                    orderMainContract:null, // 主合同编号
                    orderSubContract:null, // 分合同编号
                    orderProjectCode:null, // 项目编号
                    orderProjectName:null, // 项目名称
                    orderCategory:null, // 订单类型
                    orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                    saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    zCode:null, // 分销渠道编码-子编码
                    customerChannelCode:null, // 客户渠道
                    isStockUp:null, // 是否备货      1：是；0：否
                    orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                    instid:null, // 流程id
                    taskId:null, // 流程id
                    tuihyy:null, // 退货原因
                    tuihyydes:null, // 退货原因说明
                    contactName:null, // 联系人名称
                    receivedTime:null, // 预计收货时间
                    soldToCode:null, // 售达方编码
                    soldToName:null, // 售达方名称
                    soldToAreaCode:null, // 售达方地区编码
                    soldToAreaName:null, // 售达方地区名称
                    shipToCode:null, // 送达方编码
                    shipToName:null, // 送达方名称
                    shipToAreaCode:null, // 送达方地区编码
                    invoiceCode:null, // 开票方编码
                    payerCode:null, // 付款方编码
                    currencyCode:null, // 币种编码
                    orderPrice:null, // 订单总价
                    exchange:null, // 对人民币的汇率
                    orderPriceRbm:null, // 订单总价rmb
                    orderPriceXj:0, // 订单现金占用
                    creditid:null, // 信贷id
                    orderPriceXd:0, // 订单信贷占用
                    orderNetWorth:null, // 订单净价值
                    poId:null, // PO号
                    areaId:null, // 区域详情表关联id
                    dcCode:null, // 配送中心编码
                    toProvincesCode:null, // 送达省份编码
                    toCityCode:null, // 送达城市编码
                    note:null, // 订单备注
                    note1:null,//产品备注
                    postcode:null, // 邮政编码
                    firsttelephone:null, // 第一个电话
                    secondtelephone:null, // 第二电话
                    extraPrice:null, // 定制加价
                    customized:null, // 定制需求
                    sapsended:null, // 是否已提交sap,1-是,0-否
                    toAddress:null, // 收货地址
                    toCompanyname:null, // 送达方公司全称
                    posnr:null, // 外销:销售和分销凭证的项目号
                    inco1:null, // 外销:国际贸易条款 (部分1)
                    inco2:null, // 外销:国际贸易条款 (部分2)
                    submitflag:null,//提交标志
                    gjmytk:null, //国际贸易条款
                    fktj:null, //付款条件
                    categoryName:null,
                    category1Name:null,
                    saleGrputName:null,
                    disChannelName:null,
                    zcodeName:null,
					costCenter:null,
					businessReason:null,

                    allNum:0,
                    allhjmaozh:0,
                    allhjjinzh:0,
                    allhjtiji:0,

                    //汇总的佣金保费运费
                    allfeeyongj:0,
                    allfeebaof:0,
                    allfeeyunf:0,

                    boxing:null,
                    boxNum:null,
                    attachment:null,
                    overseaShname:null,
                    isXietong:0, // 是否协同收入
                },

                //产品list
                productlist1:[],

                //用户信贷list
                creditData:[],
                disabled:false,

                //是否计算信贷
                creditFlag:false,
                extraPrice1:0,
                ycExchange:null,//预测单创建月汇率
                showXietong:true,
            }
        },
        //页面加载前事件
        created() {
            let id = this.$route.query.ywid;
            let instid = this.$route.query.instid;
            let taskid = this.$route.query.taskid;
            let taskstatus = this.$route.query.taskstatus|0;

            let chongXinTiJiao = this.$route.query.chongXinTiJiao;

          this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
          //代办打开的
            if(id && instid){
                this.resubmit = true;

                //如果不是重新提交,则不能添加跟删除了
                if(!chongXinTiJiao){
                    this.showaddProductRow = false;
                    //this.showdelProductRow = false;
                }

                this.instid = instid;
                this.taskstatus = taskstatus;
                this.order.taskId = taskid;
                if(taskstatus == '1'){
                    // 直接设置经销商
                    this.selectDailishang = false;
                    const parent = document.querySelector(".input");
                    parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
                    //2.在设置input属性
                    //获取input
                    const input = document.querySelector(".input input");
                    //设置input的属性为false
                    input.disabled = false;
                }
            }
            this.getOrder(id||this.$route.query.id);
            this.getQycountry();
        },
        mounted(){

        },
        computed:{
            xsqyStr() {
                this.disabled = false;
                if(this.order.category2Name){
                    return this.order.categoryName +"/"+ this.order.category1Name +"/"+ this.order.category2Name
                }else if(this.order.category1Name){
                    if(this.order.category1Name =='外销标准订单'){
                        this.disabled = true;
                    }
                    return this.order.categoryName +"/"+ this.order.category1Name
                }
                return this.order.categoryName
            },
            xszzStr() {
                if(this.order.saleGroupCode != '' && this.order.saleGroupCode != null){
                    //如果是元析
                    if(this.order.saleGroupCode=='44U0'){
                        this.isYX = true;
                    }
                    return "["+this.order.saleGroupCode+"]"+this.order.saleGrputName
                }
            },
            fxqdStr() {
                if(this.order.zcodeName){
                    return this.order.disChannelName +"/"+ this.order.zcodeName
                }
                return this.order.disChannelName
            }
        },
        watch:{
            productlist1:{
                deep: true,
                handler(newValue, oldValue) {

                    console.log("列表的刷新：",newValue)
                    // new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice||0).plus(scope.row.feeyongj||0)
                    // .plus(scope.row.feebaof||0).plus(scope.row.feeyunf||0).plus(scope.row.extraPrice||0)
                    // .plus(scope.row.feebaof||0).plus(scope.row.feeyunf||0).plus(scope.row.extraPrice||0)
                    newValue.specialPrice= parseFloat(newValue.specialPrice)||0;
                    newValue.expoPrice= parseFloat(newValue.expoPrice)||0;
                    newValue.proBenchmarkPrice= parseFloat(newValue.proBenchmarkPrice)||0;
                    newValue.feeyongj= parseFloat(newValue.feeyongj)||0;
                    newValue.feebaof= parseFloat(newValue.feebaof)||0;
                    newValue.feeyunf= parseFloat(newValue.feeyunf)||0;
                    newValue.extraPrice= parseFloat(newValue.extraPrice)||0;
                    _.forEach(newValue,(o,i)=>{
                        o.totalpricermb = new big(o.totalprice).times(o.exchangermb).toFixed(2);

                    });
                    //计算总金额
                    this.order.orderPrice = _.reduce(_.map(newValue,"totalprice"),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)
                    this.order.orderPriceRbm = new big(this.order.orderPrice).times(this.order.exchange||0).toFixed(2);
                    if(this.needxindai && this.creditFlag){
                        //this.order.orderPriceXd = new big(this.order.orderPrice).times(this.order.exchange||0).toFixed(2);
                        this.order.orderPriceXd = this.order.orderPrice;
                    }
                    //件数合计
                    this.order.allNum = _.reduce(_.map(newValue,(o)=>{return new big(o.proNumber)}),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)
                    //毛净体合计
                    this.order.allhjmaozh = _.reduce(_.map(newValue,(o)=>{return new big(o.wlmaozh).times(o.proNumber||0)}),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)
                    this.order.allhjjinzh = _.reduce(_.map(newValue,(o)=>{return new big(o.wljinzh).times(o.proNumber||0) }),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)
                    this.order.allhjtiji = _.reduce(_.map(newValue,(o)=>{return new big(o.wltiji).times(o.proNumber||0) }),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)
                    this.order.allfeeyongj = _.reduce(_.map(newValue,(o)=>{return new big(o.feeyongj).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
                      return new big(sum).plus(v).toString();
                    },0)
                    this.order.allfeebaof = _.reduce(_.map(newValue,(o)=>{return new big(o.feebaof).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
                      return new big(sum).plus(v).toString();
                    },0)
                    this.order.allfeeyunf = _.reduce(_.map(newValue,(o)=>{return new big(o.feeyunf).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
                      return new big(sum).plus(v).toString();
                    },0)
                    if (newValue.length == '0'){
                        this.isAddress = false;
                    }
                    this.creditChange(this.order.creditid)
                },
            }
        },
        methods: {
            formatterZhifakufa(row, cellValue) {
                if(row.proType=='OEM') {
                    //zhifakufa;//直发库发1：直发，2：库发
                    if (row.zhifakufa == 1) {
                        return '直发'
                    } else if (row.zhifakufa == 2) {
                        return '库发'
                    } else {
                        return ''
                    }
                }else{
                    return '自产'
                }
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            getOrder(id){
                console.log("订单信息0：",this.order);
                ss.OrderMainService.selectById(id).then(rd=>{
                    console.log("订单信息1：",rd);
                    _.assign(this.order,rd.obj)
                    console.log("订单信息2：",this.order);

                    this.ddlx = this.order.orderCategory+","+(this.order.orderCategory1||'');
                    console.log('我在这儿呀11', this.ddlx);
                    var type = this.order.orderCategory1||'';
                    //项目编码
                    this.xmcode = this.order.orderProjectCode;

                  /*  if(this.order.kucun == null || this.order.kucun == ''){
                        if(this.order.orderCategory == '2' && this.order.orderCategory1 == '24'){
                            if(rd.obj.products.length > 0 && (rd.obj.products[0].factory == '1RK0' || rd.obj.products[0].factory == '1R60'|| rd.obj.products[0].factory == '0PN0')){
                                this.order.kucun = "0098";
                            }else {
                                this.order.kucun = "0099";
                            }
                        }else if(this.order.orderCategory == '2' && this.order.orderCategory1 == '21'){
                            //标准自产订单，产地是1RK0时，库位0098,产地6200时，库位0099
                            if(rd.obj.products.length > 0 && rd.obj.products[0].factory == '1RK0'){
                                this.order.kucun = "0098";
                            }else if(rd.obj.products.length > 0 && rd.obj.products[0].factory == '6200'){
                                this.order.kucun = "0099";
                            }else {
                                this.order.kucun = "0089";
                            }
                        } else {
                            this.order.kucun = "0089";
                        }
                    }*/

                  //免费订单
                  if (type == '23') {
                    this.showIsFree = true;
                    ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
                      this.costList = rd;
                    })
                                //    改制订单
                  }else if (type == '22') {
                        //    改制订单
                      this.dingzhishowflag = true;
                  }
                    //付款条件
                    this.setFkfsXindai(this.order.fktj);

                    // --------获取完售达方，在设置行项目行项目
                    if(rd.obj.products && rd.obj.products.length>0){
                        //如果免费订单 成本中心赋值
                        if (type == '23') {
                            this.order.costCenter = rd.obj.products[0].costCenter;
                        }
                        //加载完现金跟信贷，在插入行项目
                        Promise.all([this.getCredit()]).then(()=>{
                            rd.obj.products.forEach((obj)=>{
                                if(obj){
                                    if(!this.order.sapCode){
                                        this.order.sapCode=obj.sapCode;
                                    }
                                    obj.extraPriceN = obj.extraPrice;
                                    this.addProject(obj)
                                }
                            })
                            //重新获取一遍信贷
                            this.getCredit();
                            this.iAddress();
                        })
                    }
                    //已有经销商
                    if(this.order.soldToCode){
                        ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd=>{
                            this.choseshoudf(rd,true);
                        })
                    }
                    this.ruleC();

                })
            },

            //当国际贸易条款为FOB和EXW时，去除产品信息列表保费、运费两列显示
            ruleC(){
                if (this.order.gjmytk == 'FOB' || this.order.gjmytk == 'EXW') {
                    //console.log("条件进入？")
                    this.showFee = false;
                    if(this.productlist1 && this.productlist1.length>0){
                        for(var i=0;i<this.productlist1.length;i++){
                            var o = this.productlist1[i];
                            o.feeyunf = 0;
                            o.feebaof = 0;
                        }
                    }
                } else {
                    this.showFee = true;
                }
            },

    //         有个付款方式，TT只用现金，不能选信贷，
    // 其他的类型：什么60、90、120啥的必须选择信贷，信贷的账期必须大于等于付款方式的账期。现金跟信贷不能混用。
    // 信用证：现金跟信贷都不能占用，财务审核过了就行
            changeFktj(o){
                //重置信贷
                this.order.creditid='';
                this.order.orderPriceXd = 0;
                this.needxinjin = true;
                this.needxinjin = true;
                this.setFkfsXindai(o.code);

            },
            setFkfsXindai(fkfs){
                // HT02: T/T Advance
                // LC50: 信用证
                // fjksnotjy:['HT02','LC50'],
                if(_.includes(['HT02','LC50','LCHY','LC5M'], fkfs)){
                    //信用证
                    if(fkfs == "LC50" || fkfs == "LCHY" || fkfs == "LC5M"){
                        this.shifouxinyzh = true;
                        this.needxinjin = false;
                    }else{
                        this.shifouxinyzh = false;
                    }
                    this.needxindai=false;
                }else{
                    // 有个付款方式，TT只用现金，不能选信贷，
                    // 只能用信贷，不能用现金
                    this.needxinjin = false;
                    this.needxindai = true;
                    this.shifouxinyzh = false;
                    this.getCredit()
                }

            },
            viewpress(r){
                this.showhistory = true;
            },
            backtolist(){
              this.$router.go(-1);
            },
            saveOrSubmit(v){
                //判断有没有错误有错误不允许重复提交
                if(this.errorMsg!=''){
                    this.$msg.msge(this.errorMsg);
                    return;
                }

                let countryList = this.$store.getters.dictlist("YLCountry_agent");
                //提交时校验是否过期送达方区域
                let countryName = _.find(countryList,{code:this.order.shipToAreaCode}).name;
                if(countryName.indexOf('停用')!=-1){
                    this.$msg.msge("送达方区域已停用请重新选择！");
                    return;
                }

                this.order.orderStatus=v
                var sumFlag = false
                var factory = this.productlist1[0].factory;
                // 校验是否大于预测剩余数量
                var type = this.order.orderCategory1||'';
                this.productlist1.forEach((item,index) => {
                    if(item.proNumber > item.availableNum){
                        this.$msg.msge("编号为: " + item.materialCode + " 的产品下单数量大于预测数量,请重新操作!");
                        sumFlag = true;
                        return;
                    }
                    if(item.factory == '' || item.factory == null){
                        this.$msg.msge("产地不能为空！");
                        sumFlag = true;
                        return;
                    }
              /*      if(item.factory != factory){
                        this.$msg.msge("所选产品产地不唯一，不允许提交！");
                        sumFlag = true;
                        return;
                    }*/
                    if(item.kucun == '' || item.kucun == null){
                        this.$msg.msge(item.materialCode+"请选择库位！");
                        sumFlag = true;
                        return;
                    }

                  //如果是oem标准订单,免费订单,产品是oem并且产地是6200发货方式为直发,收货地址必填
                    if(type == '24' || type == '23'){
                      if(item.factory == '6200' && item.proType == 'OEM'
                          && item.zhifakufa == '1' && (this.order.toAddress == '' || this.order.toAddress == null)){
                        this.$msg.msge("请填写收货地址！");
                        sumFlag = true;
                        return;
                      }
                    }

                });
                // 校验是否大于特价余量
                // this.productlist1.forEach((item,index) => {
                //     if(item.proNumber > item.specialPriceNum){
                //         this.$msg.msge("编号为: " + item.materialCode + " 的产品下单数量大于特价余量,请重新操作!");
                //         sumFlag = true;
                //         return;
                //     }
                // });
                if(sumFlag){
                    return;
                }
                // var sfdxy = _.every(this.productlist1,function(o) {
                //     return o.ycavailableNum>proNumber; })

                if(v=='10'){
                    this.order.submitflag='暂存'
                }else if(v=='20'){
                    this.order.submitflag='提交'
                }
                if(this.order.shipDate=='' || this.order.shipDate==null){
                    this.$msg.msge("船期不能为空")
                    return
                }
                //循环设置
				// _.forEach(this.productlist1,(value)=>{
				// 	value.costCenter = this.order.costCenter;
                //     value.extraDes = _.join(value.extraDesids||[],",");
				// });

                for(var i=0;i<this.productlist1.length;i++){
                    var value = this.productlist1[i];
                    value.costCenter = this.order.costCenter;
                    if (value.specialPrice == null || value.specialPrice == '') {
                        if(((value.expoPrice - value.extraPrice||0) < value.proBenchmarkPrice) && !this.showIsFree && !this.isYX){
                            this.$msg.msge("第"+(i+1)+"行，销售单价:"+value.expoPrice+"（成交价-运保佣-定制加价）要高于基准价，若不满足条件，请申请特价");
                            return;
                        }
                    }
                    if (value.extraPrice != null || value.extraPrice != '') {
                        if(value.extraPrice - value.extraPriceN < 0){
                            this.$msg.msge("第"+(i+1)+"行，修改后的改制加价不能低于原预测单改制加价！");
                            return;
                        }
                    }
                }

                this.order.products = this.productlist1;
                if(this.order.submitflag=='提交'){

                    if(this.needxindai && this.order.orderCategory1 != '23'){
                        if(this.order.creditid == '' || this.order.creditid == null){
                            this.$msg.msge("请选择信贷后再提交！");
                            return;
                        }
                    }
                    //国际贸易条款为CIF时，运费和保险不能为0
                    var ybFlag = true;
                    if(this.order.gjmytk == 'CIF' && this.order.orderCategory1 != '23'){
                        for(var i=0;i<this.productlist1.length;i++) {
                            var value = this.productlist1[i];
                            if(value.specialOfferCode || (value.feebaof > 0 && value.feeyunf > 0)){
                                ybFlag = false;
                            }
                        }
                        if(ybFlag){
                            this.$msg.msge("国际贸易条款为CIF时,运费保费不能为0！");
                            return;
                        }
                    }

                    this.$refs['form1'].validate((valid1) => {
                        if (valid1) {
                            this.$msg.confirm("确认提交？",()=>{
                                this.submitForm();
                            })
                        }else{
                            this.$msg.msge("请完善基本信息后提交");
							return;
                        }
                    });

                }else{
                    this.submitForm();
                }
            },
            submitForm(){
                    this.submitChongfuFlag = false;
                    ss.OrderMainService.saveOrSubmit(this.order).then(rd=>{
                        this.submitChongfuFlag = true;
                        if(rd.f) {
                            if (this.order.submitflag == '提交') {
                                this.$msg.msgs("提交成功！")
                                this.$router.push({path: '/dingd/dingdwxlist'})
                            } else {
                                this.$msg.msgs("暂存成功！")
                            }
                        }else{
                            this.$msg.msge(rd.msg);
                            if (rd.msg.indexOf('提交成功') != -1){
                                this.errorMsg = rd.msg;
                            }

                        }
                    })
            },
            resaveOrSubmit(v){
                //判断有没有错误有错误不允许重复提交
                if(this.errorMsg!=''){
                    this.$msg.msge(this.errorMsg);
                    return;
                }

                let countryList = this.$store.getters.dictlist("YLCountry_agent");
                //提交时校验是否过期送达方区域
                let countryName = _.find(countryList,{code:this.order.shipToAreaCode}).name;
                if(countryName.indexOf('停用')!=-1){
                    this.$msg.msge("送达方区域已停用请重新选择！");
                    return;
                }

                this.order.orderStatus=v
//循环设置
                for(var i=0;i<this.productlist1.length;i++){
                    var value = this.productlist1[i];
                    value.costCenter = this.order.costCenter;
                    // value.extraDes = _.join(value.extraDesids||[],",");

                    if (value.specialPrice == null || value.specialPrice == '') {
                        if(value.expoPrice < value.proBenchmarkPrice && !this.showIsFree && !this.isYX){
                            this.$msg.msge("第"+(i+1)+"行，销售单价不能比基准价低");
                            return;
                        }
                    }
                    if (value.extraPrice != null || value.extraPrice != '') {
                        if(value.extraPrice - value.extraPriceN < 0){
                            this.$msg.msge("第"+(i+1)+"行，修改后的改制加价不能低于原预测单改制加价！");
                            return;
                        }
                    }

                }
                // _.forEach(this.productlist1,(value)=>{
                //     value.costCenter = this.order.costCenter;
                //     value.extraDes = _.join(value.extraDesids||[],",");
                // });
                this.order.products = this.productlist1;

                if(this.needxindai && this.order.orderCategory1 != '23'){
                    if(this.order.creditid == '' || this.order.creditid == null){
                        this.$msg.msge("请选择信贷后再提交！");
                        return;
                    }
                }
                //国际贸易条款为CIF时，运费和保险不能为0
                var ybFlag = true;
                if(this.order.gjmytk == 'CIF' && this.order.orderCategory1 != '23'){
                    for(var i=0;i<this.productlist1.length;i++) {
                        var value = this.productlist1[i];
                        if(value.specialOfferCode || (value.feebaof > 0 && value.feeyunf > 0)){
                            ybFlag = false;
                        }
                    }
                    if(ybFlag){
                        this.$msg.msge("国际贸易条款为CIF时,运费保费不能为0！");
                        return;
                    }
                }
                this.$refs['form1'].validate((valid1) => {
                    if (valid1 ) {
                        this.$msg.confirm("确认提交？",()=>{
                            this.order.submitflag = '重新提报'
                                ss.OrderMainService.saveOrSubmit(this.order).then(rd=>{
                                    if(rd.f) {
                                        this.$msg.msgs("提交成功！")
                                        this.$router.push({path:'/dingd/dingdwxlist'})
                                    }else{
                                        this.$msg.msge(rd.msg);
                                        if (rd.msg.indexOf('提交成功') != -1){
                                            this.errorMsg = rd.msg;
                                        }
                                    }
                                })
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });

            },
            //查询用户，用户余额，所有信贷
            getCredit(gscode) {
                this.creditData = [];
                this.cashBalance = 0;
                if(this.order.soldToCode && this.order.fktj){
                    var params={};
                    //列表中的第一个的产品大类
                    var cpdl = _.uniq(_.map(this.productlist1,"proModelCode"));
                    if(cpdl.length == 1){
                        params.cpdlcode = cpdl[0];0
                    }
                    params.salegroupcode = this.order.saleGroupCode;
                    params.usercode = this.order.soldToCode;
                    params.fktj = this.order.fktj; // 付款提交
                    return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
                        console.log(rd)
                        this.creditData = rd.xd;
                        this.cashBalance = rd.xj ? (rd.xj.cashBalance || 0) : 0;
                        // this['order'+gscode].creditData=rd.xd;
                        // this['order'+gscode].xianjye=rd.xj.cashBalance||0;
                    })
                }
            },
            // 选择具体的信贷
            creditChange(v){
                if(v){
                    var xd = _.find(this.creditData,{id:v})
                    console.log(xd)
                    //现金，大于订单总额
                    if(xd.quota >= this.order.orderPrice ){
                        this.order.orderPriceXd = this.order.orderPrice;
                        this.creditFlag = true;
                    }else{
                        this.$msg.msge("该信贷可用余额不足，请重新选择！");
                        this.order.creditid='';
                        this.order.orderPriceXd = 0;
                        this.creditFlag = false;
                        return;
                    }
                }else{

                    this.order.creditid='';
                    this.order.orderPriceXd = 0;

                    this.creditFlag = false;
                }

            },

            //特价改变
            changeTejia(row){
                if(row.specialOfferCode){
                    const tjobj = _.find(row.tjlist,{tjdtid:row.specialOfferCode})
					console.log(tjobj.feeyongj,tjobj.feebaof,tjobj.feeyunf,"///////////")
                    row.specialPrice = tjobj.tejia;
                    row.specialPriceNum = tjobj.sysl;
                    row.feeyongj = tjobj.feeyongj != undefined?parseFloat(tjobj.feeyongj).toString():'0';//佣金
                    row.feebaof = tjobj.feebaof != undefined?parseFloat(tjobj.feebaof).toString():'0';//保费
                    row.feeyunf = tjobj.feeyunf != undefined?parseFloat(tjobj.feeyunf).toString():'0';//运费
                    row.extraPrice = row.extraPrice?parseFloat(row.extraPrice).toString():'0';
                    //带特价的这一行，不能修改销售价
                    row.expoPrice = row.specialPrice;
                    row.finalPrice =  new big(row.specialPrice).plus(row.feeyongj).plus(row.feebaof).plus(row.feeyunf).plus(row.extraPrice).toString();
                    row.expoPriceReadonly = true;
                }else{
                    row.specialOfferCode = null;
                    row.specialPrice = null;
                    row.specialPriceNum = null;
                    row.feeyongj = 0;//佣金
                    row.feebaof = 0;//保费
                    row.feeyunf = 0;//运费
                    //带特价的这一行，不能修改销售价
                    row.expoPriceReadonly = false;
                }
            },
            //选择售达方
            openShoudf(){
                this.showshdfdialog = true;
            },

            // changeflag:是否已选择售达方改变
            choseshoudf(obj,changeflag){
                console.log("选择的售达方：",obj);
                // 清空物料
                if(this.order.soldToCode != obj.usercode){
                    this.productlist1 = [];
                }
                this.order.soldToName = obj.username;
                this.order.soldToCode = obj.usercode;
                this.order.soldToAreaCode = obj.area;
                this.order.soldToAreaName = obj.areaname ;
                // this.order.gjmytk=obj.gjmytk; //国际贸易条款
                // this.order.fktj=obj.fktj; //付款条件
                this.order.currencyCode = changeflag ? this.order.currencyCode: obj.currency ;
                // 获取对人民币的汇率z
                if(this.order.currencyCode!='CNY'){
                    ss.OrderMainService.getExchange({fromCurrency:this.order.currencyCode,toCurrency:"CNY"}).then(rd => {
                        this.order.exchange = rd;
                    })
                }else{
                    this.order.exchange = 1
                }
                this.order.inco2 =  obj.gjmytk2;
                this.showshdfdialog = false
            },
            //币种改变的时候
            changeCurrencyCode(o){
                // 如果存在行项目
                this.productlist1 = [];
            },
            //删除该行项目产品信息
            deleteThis(x) {
                this.$msg.confirm("确认删除？",()=>{
                    this.productlist1 = _.reject(this.productlist1, {'id': x.id});
                    if(this.productlist1.length < 1){
                        this.dingzhishowflag = false;
                    }
                   // this.getKuwei();
                    // 再次查询一遍，查询信贷（有部分是专属信贷）
                    this.getCredit();
                    this.iAddress();
                })
            },

            //自动选择库位
            getKuwei(wl){

                if(wl.proType=='OEM'){
                    if(wl.factory=='1RK0' || wl.factory=='1R60'|| wl.factory=='0PN0' ){
                        wl.kucun = "0098";
                    }else if(wl.factory=='1S00' || wl.factory=='1S40' || wl.factory=='1S30') { //厚宏 OEM 0099
                         wl.kucun = "0099";
                    }else if(((wl.factory=='44U0' || wl.factory=='45K0') && wl.gscode=='6200')
                        || ((wl.factory=='44U0' || wl.factory=='45K0') && wl.gscode=='9390')){
                        wl.kucun = "0099";
                    }else if(wl.factory=='44U0' || wl.factory=='45K0') { //元析 OEM 0098
                        wl.kucun = "0099";
                    }else {
                        wl.kucun = "0099";
                    }
                }else{
                    if(wl.factory=='9370'){
                        wl.kucun = "7089";
                    }else if(wl.factory=='6200'){
                        wl.kucun = "0099";
                    }else if(wl.factory=='1RK0'){
                        wl.kucun = "0098";
                    }else if((wl.factory=='0PN0' && wl.gscode=='6200') || (wl.factory=='0PN0' && wl.gscode=='9390')){
                        wl.kucun = "9089";
                    }else if(wl.factory=='1S00' || wl.factory=='1S40' || wl.factory=='1S30') { //厚宏 自产 0088
                        wl.kucun = "0088";
                    }else if(wl.factory=='44U0' || wl.factory=='45K0') { //元析 自产 0088
                        wl.kucun = "0088";
                    }else{
                        wl.kucun = "0089";
                    }
                }
                if(wl.factory=='44U0' || wl.factory=='45K0') {
                    if(wl.materialType=='HALB'){
                        wl.kucun = "0066";
                    }else if(wl.materialType=='ROH'){
                        wl.kucun = "7011";
                    }
                }

                console.log(wl,"wlwlwlwlwlwl")
            },
            //选择物料
            showProcuct1() {
                if (this.order.shipToAreaCode == null || this.order.shipToAreaCode == '') {
                    this.$msg.msge("送达方区域不可为空！");
                    return;
                }
                this.showwuliaodialog1 = true;
            },
            //选择物料
            choseWuliao1(objs) {

                var mateList = [];
                for(var j=0;j<objs.length;j++){
                    mateList.push(objs[j].matecode);
                }
                ss.declaration.checkMaterial(mateList).then(rd => {
                    if(rd.f){
                        for(var i=0;i<objs.length;i++){
                            //校验是否有报关名称
                            if(!objs[i].customsName){
                                this.$message.error("报关名称为空，请先在海外报关主数据维护" + objs[i].matecode + "的中文名称！");
                                return ;
                            }
                            if(this.order.orderCategory1 == '23'){
                                //根据产地获取销售组织
                                if(objs[i].factory == '9393'){
                                    this.order.saleGroupCode = '9390';
                                }else {
                                    this.order.saleGroupCode = objs[i].factory;
                                }
                                this.order.saleGrputName = this.$store.getters.dictname("YLSalesOrganization_agent",this.order.saleGroupCode);
                                this.order.disChannelCode = '00';
                                this.order.disChannelName = this.$store.getters.dictname("fenxiao_qudao",this.order.disChannelCode);

                                ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
                                    this.costList = rd;
                                    this.order.costCenter = rd.obj.products[0].costCenter;
                                })
                            }

                            var wl = this.wlToProject(objs[i]);
                            //添加行项目
                            this.addProject(wl)
                            this.showwuliaodialog1 = false;
                            //判断是否需要填写收货地址
                            //产品是oem并且产地是6200发货方式为直发,收货地址必填
                            console.log("12313123123");
                            this.iAddress();
                            this.getKuwei(wl);
                        }

                        // 查询信贷（有部分是专属信贷）
                        this.getCredit();
                    }
                })
            },

            //判断是否展示,收货地址等字段
            iAddress(){
                this.isAddress = false;
                //产品是oem并且产地是6200发货方式为直发,收货地址必填
                this.productlist1.forEach((item,index) => {
                    if(item.proType == 'OEM' && item.zhifakufa == '1'){
                        this.isAddress = true;
                    }
                });
                console.log("是否需要收货地址：",this.isAddress);
            },

            addProject(obj){

                //    毛净体的单位
                if(this.dwzhiliang == null){
                    this.dwzhiliang = obj.wlzhongldw||'KG';
                    this.dwtiji = obj.wltijidw||'M3';
                }

                //    改制订单
                // this.dingzhishowflag = true;
                if(!this.dingzhishowflag && obj.isCustommed == '1'){
                    this.dingzhishowflag = true;
                }

                if(obj.tjlist && obj.tjlist.length>0 && !this.tejieshowflag){
                    this.tejieshowflag = true;

                }
                // 设置特价余量
                const checktejia = _.find(obj.tjlist,{tjdtid:obj.specialOfferCode})
                if(checktejia){
                    obj.specialPriceNum=checktejia.sysl
                    obj.expoPriceReadonly = true;
                }
                // this.extraPrice1 = new big(obj.extraPrice).div(obj.proNumber).toFixed(2);
                this.productlist1.push(obj);
            },
            wlToProject(obj){
                console.log("选中的物料",obj)
                var wl = {};
                wl.id=this.$util.getUuid();
                wl.materialCode=obj.matecode;//物料编码
                wl.materialName=obj.matedes;//物料名称
                wl.proModelCode=obj.cpdlcode;//产品型号编码
                wl.proModelName=obj.cpdlname;//产品型号名称
                wl.cpz = obj.cpz; //产品组
                //如果是44u0 45K0
                if(obj.factory == '44U0' || obj.factory == '45K0'){
                    if(obj.materialType == 'HALB'){
                        wl.cpz = 'NA';
                    }else if(obj.materialType == 'ROH'){
                        wl.cpz = 'ND';
                    }
                }
                wl.dwcode=obj.dwcode;//单位
                wl.dwname=obj.dwname;//单位
                wl.feeyongj=obj.feeyongj||0;//佣金
                wl.feebaof=obj.feebaof||0;//保费
                wl.feeyunf=obj.feeyunf||0;//运费
                wl.proNumber=1;//产品数量
                wl.proBenchmarkPrice=obj.jizhj;//产品基准价
                wl.expoPrice=null;//默认=产品基准价
                wl.zhifakufa=obj.delivery_method;

                //默认是可以修改的
                wl.expoPriceReadonly = false;
                wl.currencyCode=obj.currency;//币种编码
                wl.specialOfferCode=null; // 特价版本
                wl.specialPrice=null; // 特价价格
                wl.specialPriceNum=null; // 特价价格
                wl.ycid = obj.yccode;//预测人
                wl.yccountry = obj.yccountry;//预测国家
                // wl.ycavailableNum = obj.availableNum;//预测剩余数量
                wl.availableNum = obj.availableNum;
                wl.ycrcode = obj.ycrcode;//预测人
                wl.ycrname = obj.ycrname;//预测人
                wl.isCustommed=obj.isCustommed; // 是否定制     1：是   0 否

                //需要根据费率，转换成对应的币种。
                // this.order.exchange
                if(obj.extraPrice != 0 && this.order.currencyCode!='CNY'){
                    //获取预测单创建月汇率
                    ss.OrderMainService.getYcExchange({ycid:wl.ycid,fromCurrency:this.order.currencyCode,toCurrency:"CNY"}).then(rd => {
                        if(rd.f){
                            this.ycExchange = rd.msg;
                            // wl.extraPrice=new big(obj.extraPrice).div(this.ycExchange||1).toFixed(2).toString() ; // 定制加价

                            this.$set(wl,'extraPrice',new big(obj.extraPrice).div(this.ycExchange||1).toFixed(2).toString())
                            // this.extraPrice1 = wl.extraPrice ; // 定制加价
                        }
                    })
                }else{
                    wl.extraPrice=obj.extraPrice;
                }

                wl.extraDes=_.trim(obj.extraDes||'');
                wl.specificReform = obj.specificReform;
                // wl.extraDesids=null;//默认=产品基准价
                //毛净体
                wl.wlmaozh = obj.wlmaozh ; //毛重-->
                wl.wljinzh = obj.wljinzh ; //净重-->
                wl.wlzhongldw = obj.wlzhongldw; //重量单位-->
                wl.wltiji = obj.wltiji ; //体积-->
                wl.wltijidw = obj.wltijidw; //体积单位-->



                wl.finalPrice=0;//成交价
                wl.totalprice=0;//产品总价
                wl.tjlist=obj.tjlist;

                wl.fromCurrency = obj.currency;
                wl.toCurrency = this.order.currencyCode;
                //对人民币的汇率
                wl.exchangermb = this.order.exchange;
                //公司
                wl.gscode = this.order.saleGroupCode;
                wl.proType=obj.protype; //自产还是oem
                //对订单的上的币种汇率，
                wl.exchange = 1;
                //产地
                wl.factory=obj.factory;
                //报关名称
                wl.customsName=obj.customsName;
                //长宽高
                wl.measure=obj.MEASURE;
                //OEM产品描述
                wl.oemDesc = obj.oemDesc;
                wl.materialType = obj.materialType;

                // if(this.order.currencyCode == obj.currency){
                //     wl.exchange = 1
                // }else {
                //     ss.OrderMainService.getExchange({fromCurrency:obj.currency,toCurrency:this.order.currencyCode}).then(rd => {
                //         wl.exchange = rd;
                //     })
                // }
                return wl;
            },

            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            choseDizhi(obj) {
                console.log("choseDizhi",obj)
                this.order.addressCode = obj.id;
                this.order.areaId = obj.id;
                this.order.toAddress = obj.quobj.namepath;
                if(obj.zhenobj){
                    this.order.toAddress = obj.zhenobj.namepath;
                }
                this.order.toAddress = this.order.toAddress + obj.addrdetail

                this.order.toProvincesCode = obj.shengobj.name;
                this.order.toCityCode = obj.shiobj.name;

                this.showdizhiflag = false;
            },
            //有国家大区的送达方
            getQycountry(){
                let params  ={}
                ss.OrderMainService.getQycountry(params).then(rd=>{
                this.QYcountryList = rd;
              })
            },
            //区域对应的人员
            getAreaList(){
                //增加判断只允许9900000079送达方选择英国
                if(this.order.soldToCode != '9900000079' && this.order.shipToAreaCode == 'GB'){
                  this.$msg.msge("送达方区域英国不可选择！");
                  this.order.shipToAreaCode = null;
                  return;
                }
                this.areaList=[];
                this.areaUserList=[];
                this.order.businessArea=null;
              this.order.businessUser=null;
                let a = {"areacode":this.order.shipToAreaCode}
                ss.OrderMainService.getBusinessOwnerList(a).then(rd=>{
                  this.areaUserList = rd;
                  this.order.businessUser = this.areaUserList[0].ywcode
                })
            },
            calFinalPrice(row){
                if(row.specialOfferCode){
                    row.finalPrice =  new big(row.specialPrice).plus(row.feeyongj).plus(row.feebaof).plus(row.feeyunf).plus(row.extraPrice).toString();
                }
            }
        }
    }

</script>


<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        display: flex;
		justify-content: center;
		align-items: center;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }
    .jieguo .jieguo_label{
        width: 2rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value{
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }
    .h-piece {
        margin: 20px;
    }
    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }


    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
	.ljjtablepaddings3 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings3 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.ljjtablepaddings3 .ljjsales .el-input__inner{
		height: 0.3rem;
	}
	.ljjtablepaddings3 .ljjsales .el-input__icon{
		line-height: 0.42rem;
	}
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .dingzhicss{
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
